import { render, staticRenderFns } from "./main-slide.vue?vue&type=template&id=3b9e4f12&scoped=true&"
import script from "./main-slide.vue?vue&type=script&lang=js&"
export * from "./main-slide.vue?vue&type=script&lang=js&"
import style0 from "./main-slide.vue?vue&type=style&index=0&id=3b9e4f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e4f12",
  null
  
)

export default component.exports